import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Logo } from "../../components/Layouts";
import { api, storeUser, errMsg } from "../../lib/api";

export default function Auth({ register = false }) {
  const [params] = useSearchParams();
  const refFromQuery = params.get("ref") || "";
  const next = params.get("next") || "";
  const [form, setForm] = useState({ referral_code: refFromQuery });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    api.get("/auth/me")
      .then((response) => {
        storeUser(response.data);
        nav(response.data.role === "admin" ? "/admin" : (next || "/dashboard"), { replace: true });
      })
      .catch(() => {});
  }, [nav, next]);

  async function submit(event) {
    event.preventDefault();
    setError(""); setLoading(true);
    try {
      if (register && form.password !== form.password_confirm) throw new Error("Passwords do not match");
      const payload = { ...form }; delete payload.password_confirm;
      const response = await api.post(register ? "/auth/register" : "/auth/login", payload);
      storeUser(response.data);
      nav(response.data.role === "admin" ? "/admin" : (next || "/dashboard"));
    } catch (requestError) { setError(errMsg(requestError)); }
    finally { setLoading(false); }
  }

  return (
    <div className="auth-page">
      <div className="auth-aside">
        <Logo />
        <div><div className="eyebrow">THE WORLD HELP AGENCY METHOD</div><h1>Make your next move<br /><em>count.</em></h1><p>Structured participation for a more considered digital future.</p></div>
        <span className="aside-foot">Secure access · BEP20 supported</span>
      </div>
      <div className="auth-form">
        <Link to="/" className="back-link">← Back to home</Link>
        <div className="form-box">
          <div className="eyebrow">{register ? "CREATE YOUR ACCOUNT" : "WELCOME BACK"}</div>
          <h2>{register ? "Start your journey." : "Good to see you."}</h2>
          <p>{register ? "Join World Help Agency and access your member dashboard." : "Sign in to continue to your member dashboard."}</p>
          {error && <div className="error" role="alert" data-testid="auth-error">{String(error)}</div>}
          <form onSubmit={submit}>
            {register && <><label>Full Name<input data-testid="register-full-name" required onChange={(event) => setForm({ ...form, full_name: event.target.value })} /></label><label>Username<input data-testid="register-username" required onChange={(event) => setForm({ ...form, username: event.target.value })} /></label><label>Phone Number<input data-testid="register-phone" required onChange={(event) => setForm({ ...form, phone: event.target.value })} /></label></>}
            <label>Email address<input data-testid="auth-email-input" type="email" required onChange={(event) => setForm({ ...form, email: event.target.value })} /></label>
            <label>Password<input data-testid="auth-password-input" type="password" required onChange={(event) => setForm({ ...form, password: event.target.value })} /></label>
            {register && <><label>Confirm Password<input data-testid="register-password-confirm" type="password" required onChange={(event) => setForm({ ...form, password_confirm: event.target.value })} /></label><label>Referral Code <span className="optional">optional</span><input data-testid="register-referral-code" defaultValue={refFromQuery} onChange={(event) => setForm({ ...form, referral_code: event.target.value })} /></label></>}
            <button data-testid="auth-submit-button" className="btn btn-accent full" disabled={loading}>{loading ? "Please wait..." : register ? "Create account" : "Sign in"} <ArrowRight size={16} /></button>
          </form>
          <button data-testid="google-login-button" className="google-btn" disabled><span>G</span> Continue with Google <small>Coming soon</small></button>
          <div className="form-switch">{register ? "Already a member?" : "New to World Help Agency?"}{" "}<Link data-testid="auth-switch-link" to={register ? `/login${next ? `?next=${encodeURIComponent(next)}` : ""}` : `/register${next ? `?next=${encodeURIComponent(next)}` : ""}`}>{register ? "Sign in" : "Create an account"}</Link></div>
        </div>
      </div>
    </div>
  );
}